var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-layers',[_c('font-awesome-icon',{staticClass:"certificate-icon-bottom",class:{
			'certificate-icon--disabled': _vm.isDisabled,
		},attrs:{"icon":"certificate","transform":"grow-4 right-2"}}),_c('font-awesome-icon',{staticClass:"certificate-icon-top",class:{
			'certificate-icon--disabled': _vm.isDisabled,
		},attrs:{"icon":"certificate","transform":"shrink-4 right-2"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }